import gql from "graphql-tag";
const getLabsFeatureQuery = {
query: gql(` 
query GetLabFeature($userid: String!, $feature: String!, $signature: String, $component: String) {
  getLabFeature(userid: $userid, feature: $feature, signature: $signature, component: $component) {
  date
  feature
  data
  } 
}   
`),
mfa: true
}
export default getLabsFeatureQuery
